import type { ReactNode } from 'react'
import React from 'react'

import { ActionBar, Icon } from '@fourthwall/components'
import { HeartIcon } from '@fourthwall/icons'

type ThankYousBarViewProps = {
  title: ReactNode
  onClick: () => void
}

export const ThankYousBarView = ({ title, onClick }: ThankYousBarViewProps) => {
  return (
    <ActionBar title={title} icon={<Icon component={HeartIcon} height={16} />} onClick={onClick} />
  )
}
